import type { SiblingItem } from '../types/nav';

/**
 * SF-128: single source of truth for which pages belong to the Realm Part, consumed by both
 * `RealmHub` and `SiblingRow`. Reuses Sidebar.tsx's NAV_SECTIONS "Province" section item-for-item
 * (same routes, same icon paths, same pillar assignments) for Buildings/Military/Explore/Sciences.
 *
 * SF-172: one documented exception — `strategy` is appended even though it lives in Sidebar's
 * separate "Internal Affairs" section (a cross-cutting meta page, not a same-domain pillar page),
 * because it cross-cuts Buildings/Military/Sciences and needs real persistent mobile nav of its
 * own. See `constants/__tests__/realmNav.test.ts`'s `REALM_ONLY_ALLOWLIST` for the corresponding
 * drift guard. Appended *last*, not reordered to first — `RealmHub.tsx`'s desktop guard redirects
 * `/realm` to `REALM_ITEMS[0].route`, and reordering would silently change that default.
 *
 * SF-146: the former `SIBLING_ROW_ROUTES` export (a derived flat route list) is gone — superseded
 * by `constants/siblingGroups.ts`'s `findSiblingGroup`, which generalizes route resolution across
 * every registered Part (Realm, War, and future Kingdom/World follow-ups).
 */
export const REALM_ITEMS: readonly SiblingItem[] = [
  { key: 'buildings', label: 'Buildings', route: '/buildings', pillar: 'economy', iconPath: 'M3 14V6L8 2L13 6V14M3 14H13M6 14V10H10V14' },
  { key: 'military',  label: 'Military',  route: '/military',  pillar: 'military', iconPath: 'M3 3L13 13M3 3L3 6M3 3L6 3M13 3L3 13M13 3L13 6M13 3L10 3' },
  { key: 'explore',   label: 'Explore',   route: '/explore',   pillar: 'neutral', iconPath: 'M2 8A6 6 0 1012 2M2 8L6 4M2 8L6 12' },
  { key: 'sciences',  label: 'Sciences',  route: '/sciences',  pillar: 'science', iconPath: 'M6 2V6L3 12H13L10 6V2M5 2H11' },
  { key: 'economy',   label: 'Economy',   route: '/economy',   pillar: 'economy', iconPath: 'M8 2V13M4 4H12M4 4L2.5 8H5.5L4 4ZM12 4L10.5 8H13.5L12 4Z' },
  { key: 'strategy',  label: 'Strategy',  route: '/strategy',  pillar: 'neutral', iconPath: 'M3 3H13V13H3ZM3 8H13M8 3V13' },
];
